interface MetricCardProps {
  label: string;
  value: string;
  sublabel?: string;
  accent?: boolean;
}

export default function MetricCard({ label, value, sublabel, accent }: MetricCardProps) {
  return (
    <div className="bg-white rounded-xl border border-grove-300 px-6 py-5 hover:border-sage-400 hover:shadow-md transition-all duration-200">
      <p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-bark-400 mb-2">
        {label}
      </p>
      <p
        className={`text-2xl font-semibold tabular-nums tracking-tight whitespace-nowrap ${
          accent ? "text-forest-700" : "text-bark-800"
        }`}
      >
        {value}
      </p>
      {sublabel && (
        <p className="text-xs text-bark-300 mt-1.5">{sublabel}</p>
      )}
    </div>
  );
}
